import { ScrollToEndButtonComponentFactory } from './druid/types/ScrollToEndButtonMiddleware';
import useWebChatAPIContext from '/druid/internal/useWebChatAPIContext';

export default function useCreateScrollToEndButtonRenderer(): ScrollToEndButtonComponentFactory {
  return useWebChatAPIContext().scrollToEndButtonRenderer;
}
